import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";

export default function AccountBills() {
    const [items, setItems] = useState([]);
    useEffect(() => {
        api.get("/api/bills?limit=100").then((r) => setItems(r.data.bills || []));
    }, []);

    return (
        <div>
            <h1 className="font-display text-2xl md:text-3xl font-bold">My Bills</h1>
            <p className="text-[#6b7280] text-sm">{items.length} scanned • AI-verified by Fundle</p>
            <div className="space-y-2 mt-5">
                {items.length === 0 && (
                    <div className="fx-card p-10 text-center text-[#6b7280]">
                        No bills uploaded yet.
                    </div>
                )}
                {items.map((b) => (
                    <div key={b.id} className="fx-card p-4">
                        <div className="flex items-center justify-between gap-3 flex-wrap">
                            <div>
                                <p className="font-semibold">{b.extracted?.merchant_name || "Unknown merchant"}</p>
                                <p className="text-[11px] text-[#6b7280]">
                                    {new Date(b.created_at).toLocaleString("en-IN")}
                                    {b.extracted?.invoice_number && ` • Inv ${b.extracted.invoice_number}`}
                                </p>
                            </div>
                            <span
                                className={`fx-chip ${
                                    b.status === "approved"
                                        ? "bg-[#c9a959]/15 text-[#c9a959] border border-[#c9a959]/30"
                                        : b.status === "moderation"
                                        ? "bg-[#ffd700]/15 text-[#ffd700] border border-[#ffd700]/30"
                                        : "bg-[#ff4d4d]/15 text-[#ff4d4d] border border-[#ff4d4d]/30"
                                }`}
                            >
                                {b.status}
                            </span>
                        </div>
                        <div className="grid grid-cols-2 md:grid-cols-4 gap-2 mt-3 text-xs">
                            <KV k="Total" v={b.extracted?.total ? `₹${b.extracted.total}` : "—"} />
                            <KV k="Points awarded" v={b.points_awarded || 0} />
                            <KV k="Fraud score" v={`${Math.round(b.fraud_score || 0)}/100`} />
                            <KV k="Confidence" v={`${Math.round(b.confidence_score || 0)}%`} />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

function KV({ k, v }) {
    return (
        <div className="rounded-lg bg-white/[0.03] border border-[rgba(11,20,55,0.05)] px-3 py-2">
            <p className="text-[10px] uppercase tracking-widest text-[#6b7280]">{k}</p>
            <p className="text-[#0b1437] truncate">{v}</p>
        </div>
    );
}
